import Vue from 'vue'
import { bloqueiaEnter } from './global'
Vue.directive('bloqueia-enter', {
    inserted: function (el) {
        el.addEventListener('keypress', function( e ) {
            return bloqueiaEnter(e) 
        }, true)
    }
})